import { HOTEL_SKELETON_IMAGE } from '@/app/constants'
import classNames from 'classnames'
import Image from 'next/image'
import { FC } from 'react'

const HotelListItemPlaceholder: FC = () => {
	return (
		<>
			<div className="hotel-card-placeholder flex max-md:flex-col md:flex lg:h-[236px] md:p-2 bg-white rounded-4xl shadow-md border border-text-300">
				{/* Image column */}
				<div className="w-full shrink-0 md:w-[192px] xl:max-xlg:w-[192px] lg:w-auto  rtl:md:mr-0 rtl:md:ml-6 md:mr-6 rounded-4xl overflow-hidden">
					<Image
						src={HOTEL_SKELETON_IMAGE}
						width={280}
						height={220}
						alt={'placeholder image'}
						className="animate-placeholder max-md:!h-[170px] max-md:w-full md:max-xlg:h-[220px] rounded-4xl  overflow-hidden object-cover"
					/>
				</div>

				{/* Content column */}
				<div className="w-full md:min-w-[211px] md:max-xlg:grow xlg:w-[524px] flex flex-col justify-between max-md:px-4 max-md:py-3">
					<div>
						<div className="flex max-md:flex-col-reverse max-md:items-start items-center">
							<div className="rtl:mr-0 rtl:ml-2 mr-2 w-full lg:flex flex-row-reverse justify-end items-center">
								<div className="hotel-card-placeholder__title h-5 bg-text-300 rounded-4xl w-3/4 lg:w-[286px] mb-2"></div>
							</div>
						</div>
						<div className="flex items-center mb-2 max-md:flex-col max-md:justify-start max-md:items-start">
							<div className="flex md:hidden h-3 w-full bg-text-300 rounded-4xl animate-placeholder"></div>
							<div className="flex items-center max-md:my-6">
								<div className="rounded w-4 h-4 bg-text-300 mr-1 rtl:mr-0 rtl:ml-1 animate-placeholder" />
								<div className="h-3 w-[100px] bg-text-300 rounded-4xl me-2.5 animate-placeholder"></div>
								<div className="h-3 w-[100px] bg-text-300 rounded-4xl animate-placeholder "></div>
							</div>
						</div>
					</div>

					<div className="flex max-md:hidden max-md:border-b border-text-200">
						<div className="h-5 w-[100px] bg-text-300 rounded-xl me-2 animate-placeholder" />
						<div className="h-5 w-[100px] bg-text-300 rounded-xl animate-placeholder" />
					</div>

					<div className="flex border-t border-text-200 items-center justify-between md:hidden py-3 rounded-4xl bg-white">
						<div className="flex flex-col">
							<div className="h-5 w-[110px] bg-text-300 rounded-4xl  animate-placeholder"></div>
							<div className="h-3 w-[140px] bg-text-300 rounded-4xl mt-2 animate-placeholder "></div>
							<div className="h-3 w-[120px] bg-text-300 rounded-4xl mt-2 animate-placeholder "></div>
						</div>
						<div className="rounded-4xl w-[124px] h-11 bg-text-300 mr-1 animate-placeholder" />
					</div>

					<div className="hidden md:flex justify-between space-x-2 border border-text-200 rounded-2xl p-2">
						{[1, 2, 3].map((_, i) => (
							<div
								key={i}
								className={classNames('relative flex items-center w-full')}
							>
								<div className="flex flex-col items-center p-1.5 mx-auto">
									<div className="w-16 h-3 bg-text-300 rounded-full mb-1 animate-placeholder"></div>
									<div className="w-9 h-3 bg-text-300 rounded-4xl animate-placeholder"></div>
								</div>
							</div>
						))}
					</div>
				</div>

				{/* View deal column */}
				<div className="hidden md:min-w-[216px] md:max-w-[230px] md:flex flex-col justify-between items-start ms-8 md:max-xlg:ms-4 ">
					<div className="flex items-center mb-2">
						<div className="w-8 h-8 bg-text-300 rounded-3xl  rounded-br mr-2"></div>
						<div className="flex flex-col gap-1">
							<div className="w-[60px] h-3 bg-text-300 rounded-4xl"></div>
							<div className="h-3 w-[80px] bg-text-300 rounded-4xl"></div>
						</div>
					</div>
					<div>
						<div className="hotel-card-placeholder__price md:mt-0 md:w-44 h-9 bg-text-300 rounded-4xl w-[100px] mb-2"></div>
						<div className="hotel-card-placeholder__price md:mt-0 md:w-44 h-3 w-[150px] bg-text-300 rounded-4xl"></div>
					</div>
					<div className="flex w-full">
						<div className="hotel-card-placeholder__button md:w-40 h-11 bg-text-300 rounded-full w-full"></div>
					</div>
				</div>
			</div>
		</>
	)
}

export default HotelListItemPlaceholder
